import { render } from "./CResultGamePending.vue?vue&type=template&id=0b19b674"
const script = {}

import "./CResultGamePending.vue?vue&type=style&index=0&id=0b19b674&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__